import React from 'react'

import styles from './style.module.css'
import Header from './Header'
import BuyWidgetPreloader from '~components/BuyWidget/Preloader'
import PageLayout from '~components/PageLayout'
import { View } from '~constants/buy'

function Preloader() {
    return (
        <PageLayout contentWidth="m" header={<Header view={View.Buy} />}>
            <div className={styles.wrap} data-pointer="buy_page_preloader">
                <BuyWidgetPreloader />
            </div>
        </PageLayout>
    )
}

export default Preloader
